"use client";

import { motion } from "framer-motion";
import { Container, Globe, LucideHammer, LucideMessageCircleQuestion, Puzzle, Truck } from "lucide-react";

const services = [
  {
    icon: Truck,
    title: "Specialty Chemical Distribution",
    description: "We provide high-quality chemicals for industries like coatings, construction, pharmaceuticals, and agriculture.",
    iconBg: "bg-pink-50",
    iconColor: "text-pink-500",
  },
  {
    icon: Puzzle,
    title: "Custom Compounding and Formulations",
    description: "We source customized chemical compounds to meet specific client needs, including PVC and polyurethane solutions.",
    iconBg: "bg-red-50",
    iconColor: "text-red-500",
  },
  {
    icon: LucideMessageCircleQuestion,
    title: "Technical Expertise and Support",
    description: "We offer expert advice on chemical selection, usage, and troubleshooting to ensure optimal performance.",
    iconBg: "bg-blue-50",
    iconColor: "text-blue-500",
  },
  {
    icon: Globe,
    title: "Regional Logistics and Supply Chain",
    description: "We ensure timely chemical delivery across Africa, the Middle East, Subcontinent, and Southeast Asia.",
    iconBg: "bg-orange-50",
    iconColor: "text-orange-500",
  },
  {
    icon: LucideHammer,
    title: "Aluminum Surface Treatment Solutions",
    description: "We supply a variety of aluminum treatment products, including degreasers, etching agents, and anodizing solutions.",
    iconBg: "bg-green-50",
    iconColor: "text-green-500",
  },
  {
    icon: Container,
    title: "Wastewater and Environmental Solutions",
    description: "We provide chemicals for wastewater treatment to help industries meet environmental standards and sustainability goals.",
    iconBg: "bg-purple-50",
    iconColor: "text-purple-500",
  },
];


// Animation container and item variants
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // Adjust the delay between each card
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export function ServicesSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-blue-600 font-medium block mb-4"
          >
            Our Services
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-4xl md:text-5xl font-bold leading-none"
          >
            What we Served

          </motion.h2>
        </div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                variants={item}
                className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow py-8 px-6"
              >
                <div className="flex max-[500px]:flex-col flex-row max-[500px]:items-center items-start space-4">
                  <div className={`p-4 rounded-full ${service.iconBg}`}>
                    <Icon className={`w-8 h-8 ${service.iconColor}`} />
                  </div>
                  <div className="space-y-3 p-3 max-[500px]:text-center text-left">
                    <h3 className="font-bold text-xl">{service.title}</h3>
                    <p className="text-gray-600">{service.description}</p>
                    <a
                      href="#home"
                      className="inline-flex items-center text-blue-600 hover:underline font-medium"
                    >
                      More details
                    </a>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
